export const downloadFromUrl = (
  url: string,
  filename: string,
  { openInNew = false }: { openInNew: boolean },
) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  if (openInNew === true) {
    link.target = "_blank";
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
